import { request } from '../utils/request';

export const createIcon = payload =>
  request.post('/superadmin/pg-icon-set', payload);

export const fetchIcons = () => request.get('/superadmin/pg-icon-set');
